import { z } from 'zod/v4';

export const numberFromString = z.transform((v) => {
  if (v === '') {
    return null;
  }

  return Number.isNaN(v) ? null : Number(v);
});

export const nonNegativeInteger = z
  .number({ error: 'Invalid value' })
  .int({ error: 'Must be an integer' })
  .nonnegative({ error: 'Must be greater than or equal to 0' });

export const positiveInteger = z
  .number({ error: 'Invalid value' })
  .int({ error: 'Must be an integer' })
  .positive({ error: 'Must be greater than 0' });
